export { default } from './FrontPage';